import React from "react";
import { Col, Row, Card, Form, Button, Divider } from "antd";

import FormInput from "../common/FormInput";

const Settings = ({
  Fields,
  getFieldDecorator,
  handleSubmit,
  shopify,
  deleteShopify
}) => {
  return (
    <div style={{ marginTop: 40 }}>
      <h2>Settings</h2>
      <Divider />
      <Row style={{ marginTop: 30 }}>
        <Col span={6}>
          <h3>Shopify</h3>
        </Col>
        <Col span={16} offset={2}>
          <Card style={{ width: "100%" }}>
            <Row gutter={16}>
              <strong>Shopify Connection</strong>
              {shopify && shopify.shopify === null ? (
                <Form className="setting-form" onSubmit={handleSubmit}>
                  {Fields &&
                    Fields.map((field, index) => (
                      <Col span={12}>
                        <Form.Item
                          key={index}
                          label={field.label}
                          style={{ marginBottom: 5 }}
                        >
                          <FormInput
                            field={field}
                            getFieldDecorator={getFieldDecorator}
                          />
                        </Form.Item>
                      </Col>
                    ))}
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                    style={{ width: 150, marginTop: 10, marginLeft: 8 }}
                  >
                    Sync
                  </Button>
                </Form>
              ) : (
                <Button
                  type="danger"
                  className="login-form-button"
                  style={{ width: 200, marginLeft: 20 }}
                  onClick={deleteShopify}
                >
                  Remove Shopify
                </Button>
              )}
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Settings;
